import { erpApi } from "@/shared/axios";
import { useMutation } from "@tanstack/react-query";
import { urlBackendSoftnet } from '@/shared/constants/networking.constants';

const { post } = erpApi();

/**
 * Hook mutation para obtener la cobertura de qgis
 */
export const useObtenerNapsRed = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/obtener-naps-red`,
        params,
        true
      );
      return resp;
    },
  });
};

export const useObtenerNaps = () => {
  return useMutation({
    mutationFn: async (params: any) => {
      const resp = await post<any[]>(
        `${urlBackendSoftnet}/api/obtener-naps-puntos`,
        params,
        true
      );
      return resp;
    },
  });
};
